module.exports = __webpack_public_path__ + "img/wx3.a59b65aa.jpg";